document.addEventListener("DOMContentLoaded", () => {
    const html = document.documentElement;
  
    /* ----------------------------
       MOBILE MENU
    ----------------------------- */
    const mobileToggle = document.querySelector(".mobile_left");
    const mobileMenu = document.querySelector(".mobile-menu-container");
    const mobileOpen = document.querySelector(".mobile-open");
    const mobileClosed = document.querySelector(".mobile-closed");
    const topBar = document.querySelector(".tw-bg-primary");
    const mainMobileMenu = document.querySelector("#mobile_nav");
  
    const toggleMobileMenu = () => {
      const isOpen = mobileMenu.classList.toggle("is-open");
  
      mobileOpen.hidden = isOpen;
      mobileClosed.hidden = !isOpen;
      
      // Add/remove opened class to mobile-closed when menu is open
      if (isOpen) {
        mobileClosed.classList.add("opened");
        mobileClosed.removeAttribute("hidden");
      } else {
        mobileClosed.classList.remove("opened");
      }
  
      mainMobileMenu.classList.toggle("mobile-height", isOpen);
      html.classList.toggle("body-no-scroll", isOpen);
      if (topBar) topBar.style.opacity = isOpen ? 0 : 1;
      if(topBar) topBar.style.display = isOpen ? "none" : "block";
      if(mainMobileMenu) mainMobileMenu.style.marginTop = isOpen ? "0px" : "0";
    };
  
    mobileToggle.addEventListener("click", toggleMobileMenu);
  
    /* Close menu on Escape */
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        toggleMobileMenu();
      }
    });

    /* Close menu when clicking on menu links */
    const closeMenuOnLinkClick = (e) => {
      // Don't close if clicking on a submenu toggle or non-navigation link
      const target = e.target.closest("a");
      if (!target || target.hasAttribute("data-toggle") || target.classList.contains("mobile-nav__return-btn")) {
        return;
      }
      
      if (mobileMenu.classList.contains("is-open")) {
        toggleMobileMenu();
      }
    };

    // Add click listeners to all links in the mobile menu
    if (mainMobileMenu) {
      const menuLinks = mainMobileMenu.querySelectorAll("a");
      menuLinks.forEach(link => {
        link.addEventListener("click", closeMenuOnLinkClick);
      });
    }

    // Also handle clicks on mobile menu container links (like the cards at the top)
    if (mobileMenu) {
      const allMenuLinks = mobileMenu.querySelectorAll("a");
      allMenuLinks.forEach(link => {
        link.addEventListener("click", closeMenuOnLinkClick);
      });
    }

    // Ensure body-no-scroll is removed on page navigation (especially for collections pages)
    // This handles cases where AJAX navigation might not properly clean up
    const removeBodyNoScrollOnNavigation = () => {
      // Small delay to ensure it runs after any AJAX updates
      setTimeout(() => {
        if (document.documentElement.classList.contains("body-no-scroll")) {
          // Only remove if menu is actually closed and drawer is not open
          const isMenuOpen = mobileMenu.classList.contains("is-open");
          const isDrawerOpen = document.querySelector("collection-drawer[data-visible='true']");
          
          if (!isMenuOpen && !isDrawerOpen) {
            document.documentElement.classList.remove("body-no-scroll");
          }
        }
      }, 100);
    };

    // Check on initial page load - remove body-no-scroll if menu is not open
    const checkInitialState = () => {
      if (document.documentElement.classList.contains("body-no-scroll")) {
        const isMenuOpen = mobileMenu.classList.contains("is-open");
        const isDrawerOpen = document.querySelector("collection-drawer[data-visible='true']");
        
        if (!isMenuOpen && !isDrawerOpen) {
          document.documentElement.classList.remove("body-no-scroll");
        }
      }
    };
    
    // Check immediately and after a short delay (in case of delayed initialization)
    checkInitialState();
    setTimeout(checkInitialState, 500);

    // Listen for navigation events
    window.addEventListener("popstate", removeBodyNoScrollOnNavigation);
    
    // Also check after AJAX updates (for collections pages with filters)
    // Use a debounced approach to avoid excessive checks
    let checkTimeout;
    const debouncedCheck = () => {
      clearTimeout(checkTimeout);
      checkTimeout = setTimeout(removeBodyNoScrollOnNavigation, 200);
    };
    
    const observer = new MutationObserver((mutations) => {
      // Only check if we're on a collections page or if there are significant DOM changes
      const isCollectionsPage = window.location.pathname.includes('/collections/');
      if (isCollectionsPage) {
        debouncedCheck();
      }
    });

    // Observe the body for changes (which might indicate page updates)
    observer.observe(document.body, {
      childList: true,
      subtree: false, // Only watch direct children to reduce overhead
      attributes: false
    });
  
    /* ----------------------------
       DESKTOP DROPDOWN (SHOP)
    ----------------------------- */
    const shopButton = document.querySelector(".shop-button");
    const shopArrow = document.querySelector(".shop-arrow");
    const megaMenu = document.querySelector(".header-block-mega");
  
    if (shopButton && megaMenu) {
      const openMenu = () => {
        megaMenu.classList.add("is-open");
        shopButton.setAttribute("aria-expanded", "true");
        shopArrow.style.transform = "rotate(180deg)";
      };
  
      const closeMenu = () => {
        megaMenu.classList.remove("is-open");
        shopButton.setAttribute("aria-expanded", "false");
        shopArrow.style.transform = "rotate(0deg)";
      };
  
      const toggleMenu = (e) => {
        e.stopPropagation();
        megaMenu.classList.contains("is-open") ? closeMenu() : openMenu();
      };
  
      shopButton.addEventListener("click", toggleMenu);
  
      /* Close dropdown when clicking outside */
      document.addEventListener("click", (e) => {
        if (!megaMenu.contains(e.target) && !shopButton.contains(e.target)) {
          closeMenu();
        }
      });
  
      /* Close dropdown on Escape */
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeMenu();
      });
    }

    // Update header cart count based on upcart event: https://rokt.notion.site/UpCart-Public-API-306ee2db860881feb300f0e09d08048f#306ee2db860881749dfef373e6d7dc35
    window.upcartSubscribeCartLoaded(({ cart }) => {
      const totalQuantity = cart?.items || [];
      const totalItems = totalQuantity.reduce((sum, item) => sum + item.quantity, 0);
      const cartCountElements = document.querySelectorAll('.header__bag__count p[data-count]');
      if (cartCountElements.length) {
        cartCountElements.forEach(el => {
          el.textContent = totalItems;
          el.setAttribute('data-count', totalItems);
        });
      }
    });
  });
  